import { StateUtils } from '@spartacus/core';
import { CartEntryFullPalletNoteActionTypes } from '../actions/cart-entry-full-pallet-note.action';
import { CartActions } from '../actions/index';

export const initialState: boolean = undefined;

export function reducer(
  state = initialState,
  action: CartActions.CartEntryFullPalletNoteActions | StateUtils.LoaderAction
): boolean {
  switch (action.type) {
    case CartEntryFullPalletNoteActionTypes.AddCartEntryFullPalletNoteSuccess: {
      return true;
    }
    case CartEntryFullPalletNoteActionTypes.RemoveCartEntryFullPalletNoteSuccess: {
      return initialState;
    }
  }
  return state;
}
